import { CustomFileModel } from '../dynamic-form-components/custom-file-upload/custom-file-upload.model';
import { compareProps } from './compare-props.helper';

// return true if a.fileInstance is "equal to" (has the same properties as) b.fileInstance
export function compareCustomFileModels(a: CustomFileModel, b: CustomFileModel): boolean {
  if (a === b) {
    return true;
  }

  if (!a || !b) {
    return false;
  }

  return a.fileInstance && b.fileInstance
    ? compareFiles(a.fileInstance, b.fileInstance)
    : compareProps([
      'size',
      'name'
    ], getComparableMetadata(a), getComparableMetadata(b));
}

function getComparableMetadata(fileModel: CustomFileModel) {
  return {
    size: fileModel.fileInstance?.size ?? (fileModel.properties?.size && parseInt(fileModel.properties?.size, 10)) ?? null,
    name: fileModel.fileInstance?.name || fileModel.originalFileName
  };
}

export function compareFiles(a: File, b: File): boolean {
  if (a === b) {
    return true;
  }

  if (!a || !b) {
    return false;
  }

  return a.size === b.size && a.name === b.name && a.type === b.type && (a.lastModified ? a.lastModified === b.lastModified : true);
}
